import graphql from './graphql';

const query = /* GraphQL */ `
  query UserAchievement_extraDevelopmentPlan($userId: ID!) {
    UserAchievement_extraDevelopmentPlan(userId: $userId) {
      completed
      progress
    }
  }
`;

const UserAchievementExtraDevelopmentPlan = async ({ userId }) =>
  graphql(query, { userId })
    .then(
      // eslint-disable-next-line camelcase
      ({ UserAchievement_extraDevelopmentPlan }) =>
        // eslint-disable-next-line camelcase
        UserAchievement_extraDevelopmentPlan
    )
    .catch(err => err);

export default UserAchievementExtraDevelopmentPlan;
